export const zoomEfetivo = (elemento: Element): number => (elemento as any).currentCSSZoom || 1;
